export const VIDEO_TYPE = {
  DEFAULT: 'default',
  YOUTUBE_NORMAL: 'youtube_normal',
  YOUTUBE_SHORTS: 'youtube_shorts'
};

export const getVideoConfig = (url, image) => {
  let urlObj = new URL(url);
  let { origin, pathname } = urlObj;
  let type = VIDEO_TYPE.DEFAULT;
  let preview = image;
  let youTubeVideoId = null;
  if (origin.indexOf('youtu.be') > -1 || origin.indexOf('.youtube.') > -1) {
    if (pathname.includes('/shorts/')) {
      type = VIDEO_TYPE.YOUTUBE_SHORTS;
      youTubeVideoId = urlObj.pathname.split('/').pop().split('?')[0];
    } else {
      type = VIDEO_TYPE.YOUTUBE_NORMAL;
      youTubeVideoId = urlObj.pathname.split('/').pop();
    }
  }

  if (!preview && youTubeVideoId) {
    preview = `https://img.youtube.com/vi/${youTubeVideoId}/hqdefault.jpg`;
  }

  return { type, preview };
};
